import type { LocaleMessageBundle } from '../../types'

export const cashBookMessages: LocaleMessageBundle = {
  vi: {
    'cashBook.model': 'sổ quỹ',
    'cashBook.type.model': 'loại thu chi',
    'cashBook.fields.code': 'Mã phiếu',
    'cashBook.fields.entryDate': 'Ngày',
    'cashBook.fields.voucherType': 'Loại phiếu',
    'cashBook.fields.transactionType': 'Loại thu chi',
    'cashBook.fields.amount': 'Số tiền',
    'cashBook.fields.paymentMethod': 'Phương thức thanh toán',
    'cashBook.fields.entityType': 'Loại đối tượng',
    'cashBook.fields.entity': 'Đối tượng',
    'cashBook.fields.entityName': 'Tên đối tượng',
    'cashBook.fields.branch': 'Chi nhánh',
    'cashBook.fields.note': 'Ghi chú',
    'cashBook.fields.status': 'Trạng thái',
    'cashBook.fields.cancelReason': 'Lý do hủy',
    'cashBook.fields.direction': 'Chiều',
    'cashBook.fields.name': 'Tên',
    'cashBook.voucher.receipt': 'Phiếu thu',
    'cashBook.voucher.payment': 'Phiếu chi',
    'cashBook.direction.in': 'Thu',
    'cashBook.direction.out': 'Chi',
    'cashBook.status.posted': 'Đã ghi',
    'cashBook.status.cancelled': 'Đã hủy',
    // Nguồn sinh dòng tiền: dùng để truy vết dòng sổ quỹ về chứng từ gốc.
    'cashBook.fields.source': 'Nguồn',
    'cashBook.source.manual': 'Nhập tay',
    'cashBook.source.manualHint': 'Phiếu được nhập trực tiếp, không phát sinh từ chứng từ nào.',
    'cashBook.source.title': 'Nguồn sinh dòng tiền',
    'cashBook.source.sales_invoice': 'Hoá đơn bán hàng',
    'cashBook.source.customer_receipt': 'Phiếu thu khách hàng',
    'cashBook.source.supplier_payment': 'Phiếu thanh toán NCC',
    'cashBook.source.sales_order_deposit': 'Đặt cọc đơn bán',
    'cashBook.source.booking_deposit': 'Cọc đặt bàn',
    'cashBook.source.purchase_shipping_payment': 'Chi phí vận chuyển nhập',
    'cashBook.source.sales_shipping_payment': 'Chi phí giao hàng bán',
    'cashBook.source.code': 'Mã chứng từ',
    'cashBook.source.entity': 'Đối tượng',
    'cashBook.source.amount': 'Giá trị chứng từ',
    'cashBook.source.documentCancelled': 'Chứng từ nguồn đã bị huỷ',
    'cashBook.source.viewDocument': 'Mở chứng từ',
    'cashBook.source.noRoute': 'Chưa có màn hình cho loại chứng từ này',
    'cashBook.entity.customer': 'Khách hàng',
    'cashBook.entity.supplier': 'Nhà cung cấp',
    'cashBook.entity.staff': 'Nhân viên',
    'cashBook.entity.delivery_partner': 'Đối tác vận chuyển',
    'cashBook.entity.other': 'Khác',
    'cashBook.paymentMethods.cash': 'Tiền mặt',
    'cashBook.paymentMethods.card': 'Thẻ',
    'cashBook.paymentMethods.transfer': 'Chuyển khoản',
    'cashBook.summary.totalIn': 'Tổng thu',
    'cashBook.summary.totalOut': 'Tổng chi',
    'cashBook.summary.net': 'Chênh lệch',
    'cashBook.actions.create': 'Thêm phiếu',
    'cashBook.actions.createType': 'Thêm loại thu chi',
    'cashBook.actions.updateType': 'Cập nhật loại thu chi',
    'cashBook.actions.cancel': 'Hủy',
    'cashBook.actions.cancelConfirm': 'Hủy',
    'cashBook.dialog.createSubtitle': 'Ghi nhận thu/chi thủ công',
    'cashBook.dialog.cancelTitle': 'Hủy phiếu',
    'cashBook.dialog.cancelSubtitle': 'Phiếu đã hủy không còn tính vào tổng',
    'cashBook.messages.cancelConfirm': 'Bạn có chắc muốn hủy phiếu {code}?',
    'cashBook.type.dialog.createSubtitle': 'Danh mục loại thu / chi',
    'cashBook.type.deleteConfirm': 'Xóa loại "{name}"?',
    'cashBook.validation.transactionTypeRequired': 'Loại thu chi cần được nhập vào.',
    'cashBook.validation.amountGreaterThanZero': 'Số tiền phải lớn hơn 0.',
    'cashBook.validation.entityRequired': 'Đối tượng là bắt buộc.',
    'cashBook.validation.entityNameRequiredWhenOther':
      'Tên đối tượng là bắt buộc khi loại đối tượng là khác.',
    'cashBook.errors.loadFailed': 'Không thể tải sổ quỹ',
    'cashBook.errors.saveFailed': 'Không thể lưu',
    'cashBook.errors.cancelFailed': 'Không thể hủy phiếu',
    'cashBook.errors.cancelReasonRequired': 'Vui lòng nhập lý do hủy.',
    'cashBook.errors.cancelReasonTooLong': 'Lý do hủy không được vượt quá {max} ký tự.',
  },
  en: {
    'cashBook.model': 'cash book',
    'cashBook.type.model': 'transaction type',
    'cashBook.fields.code': 'Code',
    'cashBook.fields.entryDate': 'Date',
    'cashBook.fields.voucherType': 'Voucher type',
    'cashBook.fields.transactionType': 'Transaction type',
    'cashBook.fields.amount': 'Amount',
    'cashBook.fields.paymentMethod': 'Payment method',
    'cashBook.fields.entityType': 'Entity type',
    'cashBook.fields.entity': 'Entity',
    'cashBook.fields.entityName': 'Entity name',
    'cashBook.fields.branch': 'Branch',
    'cashBook.fields.note': 'Note',
    'cashBook.fields.status': 'Status',
    'cashBook.fields.cancelReason': 'Cancel reason',
    'cashBook.fields.direction': 'Direction',
    'cashBook.fields.name': 'Name',
    'cashBook.voucher.receipt': 'Receipt',
    'cashBook.voucher.payment': 'Payment',
    'cashBook.direction.in': 'In',
    'cashBook.direction.out': 'Out',
    'cashBook.status.posted': 'Posted',
    'cashBook.status.cancelled': 'Cancelled',
    // Origin of a cash movement: traces the voucher back to its source document.
    'cashBook.fields.source': 'Source',
    'cashBook.source.manual': 'Manual',
    'cashBook.source.manualHint': 'Entered directly, not generated from any document.',
    'cashBook.source.title': 'Cash movement source',
    'cashBook.source.sales_invoice': 'Sales invoice',
    'cashBook.source.customer_receipt': 'Customer receipt',
    'cashBook.source.supplier_payment': 'Supplier payment',
    'cashBook.source.sales_order_deposit': 'Sales order deposit',
    'cashBook.source.booking_deposit': 'Booking deposit',
    'cashBook.source.purchase_shipping_payment': 'Purchase shipping',
    'cashBook.source.sales_shipping_payment': 'Sales shipping',
    'cashBook.source.code': 'Document code',
    'cashBook.source.entity': 'Entity',
    'cashBook.source.amount': 'Document amount',
    'cashBook.source.documentCancelled': 'Source document was cancelled',
    'cashBook.source.viewDocument': 'Open document',
    'cashBook.source.noRoute': 'No screen for this document type yet',
    'cashBook.entity.customer': 'Customer',
    'cashBook.entity.supplier': 'Supplier',
    'cashBook.entity.staff': 'Staff',
    'cashBook.entity.delivery_partner': 'Delivery partner',
    'cashBook.entity.other': 'Other',
    'cashBook.paymentMethods.cash': 'Cash',
    'cashBook.paymentMethods.card': 'Card',
    'cashBook.paymentMethods.transfer': 'Bank transfer',
    'cashBook.summary.totalIn': 'Total in',
    'cashBook.summary.totalOut': 'Total out',
    'cashBook.summary.net': 'Net',
    'cashBook.actions.create': 'Add entry',
    'cashBook.actions.createType': 'Add transaction type',
    'cashBook.actions.updateType': 'Update transaction type',
    'cashBook.actions.cancel': 'Cancel entry',
    'cashBook.actions.cancelConfirm': 'Cancel',
    'cashBook.dialog.createSubtitle': 'Record manual cash in/out',
    'cashBook.dialog.cancelTitle': 'Cancel entry',
    'cashBook.dialog.cancelSubtitle': 'Cancelled entries are excluded from totals',
    'cashBook.messages.cancelConfirm': 'Are you sure you want to cancel entry {code}?',
    'cashBook.type.dialog.createSubtitle': 'Income / expense categories',
    'cashBook.type.deleteConfirm': 'Delete type "{name}"?',
    'cashBook.validation.transactionTypeRequired': 'Transaction type is required.',
    'cashBook.validation.amountGreaterThanZero': 'Amount must be greater than 0.',
    'cashBook.validation.entityRequired': 'Entity is required.',
    'cashBook.validation.entityNameRequiredWhenOther':
      'Entity name is required when entity type is other.',
    'cashBook.errors.loadFailed': 'Failed to load cash book',
    'cashBook.errors.saveFailed': 'Failed to save',
    'cashBook.errors.cancelFailed': 'Failed to cancel entry',
    'cashBook.errors.cancelReasonRequired': 'Cancellation reason is required.',
    'cashBook.errors.cancelReasonTooLong': 'Cancellation reason cannot exceed {max} characters.',
  },
}
